/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { ThreadGroups } from 'blb-components/AuthenticatedApp/DashboardPage/Inbox/types';
import { ReduxState } from '../types';
import * as _ from 'lodash';

export const getInbox = (state: ReduxState) => state.inbox;
export const getThreads = (state: ReduxState) => getInbox(state).threads;
export const getUser = (state: ReduxState) => getInbox(state).user;
export const getErrors = (state: ReduxState) => getInbox(state).errors;
export const getSelectedThread = (state: ReduxState) => getInbox(state).selectedThread;
export const getIsInitialLoad = (state: ReduxState) => getInbox(state).initialLoad;

const initializeThreadGroups = (): ThreadGroups => {
  return {
    outstanding: [],
    resolved: [],
  };
};

export const getThreadsByGroup = (state: ReduxState) => {
  const threadGroups = initializeThreadGroups();
  const threads = getThreads(state);
  _.forEach(threads, thread => {
    if (thread.isResolved) {
      threadGroups.resolved.push(thread);
    } else {
      threadGroups.outstanding.push(thread);
    }
  });

  return threadGroups;
};
